import React, {Component} from 'react';
import { Container, Row, Col, Tab, Nav, Form, Button, Spinner} from "react-bootstrap";
import { FaSave, FaRegTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { Redirect, Link } from 'react-router-dom';

import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from '../lib/Crypt';
import Loader from "./LoaderModal";
import swal from 'sweetalert';
import C from '../lib/Config';

export default class AddMedicine extends Component {
    constructor(props) {
        super(props);
        this.state = { medicineName: '', medicineDesc: '', medicineId : 0, redirect: false };
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentDidMount() {
      console.log(this.props.location);
      if(this.props.location && this.props.location.search){
        let medicineId = this.props.location.search.slice(3);
        this.setState({ medicineId: medicineId });
        this.getMedicineDetails(medicineId);
      }
    }
    handleChange(event){
        if(event.target.name === 'medicineName'){
            this.setState({medicineName: event.target.value});
        }
        if(event.target.name === 'medicineDesc'){
            this.setState({medicineDesc: event.target.value});
        }
    }

    getMedicineDetails(medicineId){
      return fetch(C.getUrl() + '/medicineMst/findMedicineById/'+medicineId, {
          method: 'GET',
          mode: 'cors',
      })
      .then(res => res.json())
      .then(res => {
          let resObj = res;
          let error = resObj.subErrors;
          if (error !== 'undefined' && error !== null && error !== "") {
              alert(error);
          } else {
              let obj = resObj.message;
          if (obj === 'No record found.') {
            
          } else {
              let data = JSON.parse(resObj.message);
              console.log(data);
              this.setState({ medicineId: data.medicineId }); 
              this.setState({ medicineName: data.medicineName }); 
              this.setState({ medicineDesc: data.medicineDesc }); 
            }
          }
      })
      .catch(err => {
          console.log("Error : " + err);
      });
    }

    saveMedicine(event){
        let data = {
              medicineName: this.state.medicineName,
              medicineDesc: this.state.medicineDesc,
              activeInd: 'Y',
              creationDate: new Date(),
              updatedDate: new Date(),
              createdByIdUser: {
                  userId: localStorage.getItem('userId')
              },
              updatedByIdUser: {
                  userId: localStorage.getItem('userId')
              }
        }
        console.log("Save data : "+JSON.stringify(data));
        return fetch(C.getUrl() + '/medicineMst/saveMedicine', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 4000, });
            } else {
                this.setState({ saveLoader: true });
                setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                swal({ title: obj.message, icon: "success", buttons: false, timer: 2000, });
                setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
                this.setState({ redirect : true });
            }
        })
        .catch(err => {
              swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    updateMedicine(event){
      let data = {
            medicineId: this.state.medicineId,
            medicineName: this.state.medicineName,
            medicineDesc: this.state.medicineDesc,
            activeInd: 'Y',
            creationDate: new Date(),
            updatedDate: new Date(),
            createdByIdUser: {
                userId: localStorage.getItem('userId')
            },
            updatedByIdUser: {
                userId: localStorage.getItem('userId')
            }
      }
      console.log("Update data : "+JSON.stringify(data));
      return fetch(C.getUrl() + '/medicineMst/updateMedicine', {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify(data),
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(res => res.json())
      .then(res => {
          let obj = res;
          let error = obj.subErrors;
          if (error !== null && error !== "") {
              swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 4000, });
          } else {
              this.setState({ saveLoader: true });
              setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
              swal({ title: obj.message, icon: "success", buttons: false, timer: 2000, });
              setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
              this.setState({ redirect : true });
          }
      })
      .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
      });
    }
  
    render() {
        const _this = this;
        const { redirect } = this.state;

        if (redirect) {
          return <Redirect to='/MedicineMaster'/>;
        }
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section">
                                    <Link to="/MedicineMaster" className="btn btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link> 
                                    <h3 className="fs-18 ml-3 header_title text-black mb-4">Add Medicine</h3>
                                    <div className="dropdown-divider pb-2"></div>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Medicine Name </Form.Label>
                                        <Col sm="9">
                                            <Form.Control type='text' placeholder='' name='medicineName' onChange={this.handleChange} value={this.state.medicineName} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Medicine Description </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as='textarea' placeholder='' maxLength='65535' rows={2} name='medicineDesc' onChange={this.handleChange} value={this.state.medicineDesc} />
                                        </Col>
                                    </Form.Group>
                                    <Row>
                                        <Col lg='12'>
                                            <div className="form-button text-center">
                                                {(() => {
                                                    if (this.state.medicineId === 0) {
                                                        return (
                                                          <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveMedicine.bind(this)}>
                                                              {this.state.saveLoader && (
                                                                  <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                              )}
                                                              {!this.state.saveLoader && (
                                                                  <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                              )}
                                                              Save
                                                          </Button>
                                                        )
                                                      }
                                                  })()
                                                }
                                                {(() => {
                                                    if (this.state.medicineId !== 0) {
                                                        return (
                                                          <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.updateMedicine.bind(this)}>
                                                              {this.state.saveLoader && (
                                                                  <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                              )}
                                                              {!this.state.saveLoader && (
                                                                  <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                              )}
                                                              Update
                                                          </Button>
                                                        )
                                                      }
                                                  })()
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}